import { net_filemanage } from "@/api/http";
export const API_STFMFM02C07_DisplayProperty = (...params) =>
net_filemanage.post("/api/STFMFM02C07/DisplayProperty", ...params)
export const API_STFMFM02C07_AddProperty = (...params) =>
net_filemanage.post("/api/STFMFM02C07/AddProperty", ...params)
export const API_STFMFM02C07_GetFileData = (...params) =>
net_filemanage.post("/api/STFMFM02C07/GetFileData", ...params)